module.exports = __webpack_public_path__ + "img/Step07.56bf50e6.webp";